import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { getOneRosterTeachersByClass, getOneRosterStudentsByClass, ClassStudentsRequestState, ClassTeachersRequestState } from "../../../store/OneRoster/OneRosterClassAction";
import StatusCode from "../../../util/StatusCode";
import ActiveToggle from "../../misc/ActiveToggle";
import TableHorizontalPagedToggle from "../../misc/TableHorizontalPagedToggle";
import { useTranslation } from 'react-i18next';
import * as Helper from '../../../util/Helper';
import { RootState } from "../../../store/store";



const OneRosterClassMembers = () => {
    const { t } = useTranslation(['common', 'oneRoster']);

    const { eventId } = useParams();
    const dispatch = useDispatch();
    const [show, setShow] = useState({ students: true, teachers: true });

    const students = useSelector<RootState, ClassStudentsRequestState>(state => state.onerosterClass.studentsByClass);
    const teachers = useSelector<RootState, ClassTeachersRequestState>(state => state.onerosterClass.teachersByClass);

    useEffect(() => {
        if (eventId) {
            getOneRosterTeachersByClass(eventId, { ...teachers?.filter })(dispatch);
            getOneRosterStudentsByClass(eventId, { ...students?.filter })(dispatch);
        }
    }, [dispatch, eventId]);

    const updateStudentsPage = (value: number) => {
        if (eventId) {
            getOneRosterStudentsByClass(eventId, { ...students.filter, page: value })(dispatch);
        }
    };

    const updateTeachersPage = (value: number) => {
        if (eventId) {
            getOneRosterTeachersByClass(eventId, { ...teachers.filter, page: value })(dispatch);
        }
    };

    const updateOnlyActive = (value: boolean) => {
        if (eventId) {
            getOneRosterStudentsByClass(eventId, { ...students.filter, onlyActive: value, page: 1 })(dispatch);
            getOneRosterTeachersByClass(eventId, { ...teachers.filter, onlyActive: value, page: 1 })(dispatch);
        }
    };

    const mapStudents = () => {
        if (students.code !== StatusCode.COMPLETE) {
            return [];
        }
        return students.data.values.map(x => ({
            id: x.id,
            data: [
                { value: <Link to={`/oneroster/user/${x.id}/information`}>{`${x.givenName} ${x.familyName}`}</Link> },
                { value: x.email },
                { value: Helper.active(x.active) },
                { value: x.userName },
            ]
        }));
    }

    const renderStudents = () => {
        const count = Helper.getTotalCountText(students);
        return (
            <TableHorizontalPagedToggle
                header={[{ value: `${t('commonTableHeaders.students', { ns: 'oneRoster' })} ${count}` }, { value: t('commonTableHeaders.email', { ns: 'oneRoster' }) }, { value: t('genericTableHeaders.active', { ns: 'common' }) }, { value: t('commonTableHeaders.userName', { ns: 'oneRoster' }) }]}
                mobileHeader={[t('genericTableHeaders.name', { ns: 'common' }), t('commonTableHeaders.email', { ns: 'oneRoster' }), t('genericTableHeaders.active', { ns: 'common' }), t('commonTableHeaders.userName', { ns: 'oneRoster' })]}
                info={mapStudents()}
                show={show.students}
                toggle={() => setShow({ ...show, students: !show.students })}
                displayName={`${t('commonTableHeaders.students', { ns: 'oneRoster' })} ${count}`}
                onChangePage={(p) => updateStudentsPage(p)}
                noResultMsg={t('notFound.sectionStudents', { ns: 'oneRoster' })}
                requestState={students}
            />
        );
    }

    const mapTeachers = () => {
        if (teachers.code !== StatusCode.COMPLETE) {
            return [];
        }

        return teachers.data.values.map(x => ({
            id: x.id,
            data: [
                { value: <Link to={`/oneroster/user/${x.id}/information`}>{`${x.givenName} ${x.familyName}`}</Link> },
                { value: x.email },
                { value: Helper.active(x.active) },
                { value: x.userName },
            ]
        }));
    }

    const renderTeachers = () => {
        const count = Helper.getTotalCountText(teachers);
        return (
            <TableHorizontalPagedToggle
                header={[{ value: `${t('commonTableHeaders.teachers', { ns: 'oneRoster' })} ${count}` }, { value: t('commonTableHeaders.email', { ns: 'oneRoster' }) }, { value: t('genericTableHeaders.active', { ns: 'common' }) }, { value: t('commonTableHeaders.userName', { ns: 'oneRoster' }) }]}
                mobileHeader={[t('genericTableHeaders.name', { ns: 'common' }), t('commonTableHeaders.email', { ns: 'oneRoster' }), t('genericTableHeaders.active', { ns: 'common' }), t('commonTableHeaders.userName', { ns: 'oneRoster' })]}
                info={mapTeachers()}
                show={show.teachers}
                toggle={() => setShow({ ...show, teachers: !show.teachers })}
                displayName={`${t('commonTableHeaders.teachers', { ns: 'oneRoster' })} ${count}`}
                onChangePage={(p) => updateTeachersPage(p)}
                noResultMsg={t('notFound.sectionTeachers', { ns: 'oneRoster' })}
                requestState={teachers}
            />
        )
    }

    return (<>
        <div className="header_member_table large">{t('members', { ns: 'oneRoster' })}
            <span className="right">
                <ActiveToggle
                    onlyActive={students.filter?.onlyActive ?? true}
                    update={(active) => updateOnlyActive(active)}
                    disabled={students.code === StatusCode.PENDING || teachers.code === StatusCode.PENDING}
                />
            </span></div>
        {renderTeachers()}
        {renderStudents()}
    </>);
}

export default OneRosterClassMembers;
